module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/header/header.component.scss
// module id = ./src/app/shared/header/header.component.scss
// module chunks = main